export default __webpack_public_path__ + "static/media/b.fe553dff.svg";